export const EVENTLIST = [
        {
            day: 'LUN',
            current: true,
            events: [
                {
                    id: 1,
                    icons: ['cnas'],
                    title: 'Angela Ghica Protopopescu',
                    time: '09:00 - 09:30',
                    desc: 'Consult control gastroenterologie, Ecografie abdominală',
                    location: 'Buc. Aviatori',
                    class: 'green-bg',
                  },
                  {
                    id: 2,
                    icons: ['computer', 'nou'],
                    title: 'Alexandru Daniel Roscovici',
                    time: '07:00 - 09:30',
                    desc: 'Evaluare nivel sănătate emoțională • Donec nisi nisi, ultricies luctus massa non, commodo ultricies lectus...',
                    location: 'Buc. Aviatori',
                    class: 'blue-bg'
                  },
                  {
                    id: 3,
                    icons: ['partially-paid', 'warning-custom'],
                    title: 'Maria Iovan Plăieșu',
                    time: '14:00 - 14:20',
                    desc: 'Nunc scelerisque, nulla vel vehicula malesuada, dui nunc mattis erat, eu cursus orci urna vel mauris. ',
                    location: 'Buc. Aviatori',
                    class: 'yellow-bg'
                  },
                  {
                    id: 4,
                    icons: ['note'],
                    title: 'Rezervare slot calendar',
                    time: '16:00 - 17:00',
                    desc: 'Donec nisi nisi, ultricies luctus massa non, commodo ultricies lectus.  amet iaculis et.',
                    location: 'Buc. Aviatori',
                    class: 'orange-bg'
                  },
            ],

        },
        {
            day: 'MAR',
            current: false,
            events: [
                {
                    id: 1,
                    icons: ['recurenta'],
                    title: 'Vasile Scoarță',
                    time: '08:00 - 08:50',
                    desc: 'Etiam eu lectus orci. Fusce sit amet venenatis ex.',
                    location: 'Buc. Preciziei',
                    class: 'green-pattern'
                  },
            ],

        },
        {
            day: 'MIE',
            current: false,
            events: [
              {
                id: 1,
                icons: ['nou','user-redirect'],
                title: 'Cezar Victor Dragușin',
                time: '09:25 - 10:20',
                desc: 'Vivamus velit lacus, dictum eget massa quis, dignissim ornare tellus.',
                location: 'Buc. Preciziei',
                class: 'yellow-bg'
              },
              {
                id: 2,
                icons: ['cancelled'],
                title: 'Aneta Elena Antonesi',
                time: '10:30 - 11:20',
                desc: 'Etiam eu lectus orci. Fusce sit amet venenatis ex.',
                location: 'ANULAT',
                class: 'gray-bg'
              },
                {
                    id: 1,
                    icons: ['cnas'],
                    title: 'Angela Ghica Protopopescu',
                    time: '09:00 - 09:30',
                    desc: 'Consult control gastroenterologie, Ecografie abdominală',
                    location: 'Buc. Aviatori',
                    class: 'green-pattern'
                  },
                  {
                    id: 2,
                    icons: ['cnas'],
                    title: 'Alexandru Daniel Roscovici',
                    time: '07:00 - 09:30',
                    desc: 'Evaluare nivel sănătate emoțională • Donec nisi nisi, ultricies luctus massa non, commodo ultricies lectus...',
                    location: 'Buc. Aviatori',
                    class: 'yellow-bg'
                  },
            ],

        },
        {
            day: 'VIN',
            current: false,
            events: [
                {
                    id: 1,
                    icons: ['recurenta','cnas'],
                    title: 'Vladimir Alexandru Apetroaie',
                    time: '10:30 - 10:45',
                    desc: 'Etiam eu lectus orci. Fusce sit amet venenatis ex.',
                    location: 'On-line',
                    class: 'blue-pattern'
                  },
                  {
                    id: 2,
                    icons: ['recurenta'],
                    title: 'Aneta Elena Antonesi',
                    time: '10:30 - 11:20',
                    desc: 'Etiam eu lectus orci. Fusce sit amet venenatis ex.',
                    location: 'ANULAT',
                    class: 'yellow-bg'
                  },
                {
                    id: 3,
                    icons: ['cnas'],
                    title: 'Vladimir Alexandru Apetroaie',
                    time: '10:30 - 10:45',
                    desc: 'Etiam eu lectus orci. Fusce sit amet venenatis ex.',
                    location: 'On-line',
                    class: 'blue-pattern'
                  },
            ],

        }
    ];
